<div>
    @switch (observationVariable.dataTypeCode) {
        @case ('C') {
            @if (isLocation()) {
                <jhi-locations-select [selectWidth]="'100%'"
                                      (blur)="handleBlur()"
                                      (keyDown)="handleKeyDown($event)"
                                      [showFilterOptions]="true"
                                      [showDivider]="true"
                                      [(value)]="cellData.model[bindProperty]"
                                      [appendTo]="'body'"
                                      [clearable]="locationSelectClearable"
                                      (onLocationChanged)="onLocationChanged($event)">
                </jhi-locations-select>
            }

            @if (isBreedingMethod()) {
                <jhi-breeding-methods-select [selectWidth]="'100%'"
                                             [showAllMethodTypesOption]="false"
                                             [showDerivativeMethodTypesOption]="false"
                                             [showGenerativeMethodTypesOption]="false"
                                             [breedingMethodFilterTypeValue]="breedingMethodFilterType"
                                             [showFavoritesCheckbox]="false"
                                             [customClass]="'ng-select-inline-edit'"
                                             [appendTo]="'body'"
                                             (blur)="handleBlur()"
                                             (keyDown)="handleKeyDown($event)"
                                             (onMethodChanged)="onMethodChanged($event)">
                </jhi-breeding-methods-select>
            }

            @if (!isLocation() && !isBreedingMethod() && categoricalItems && categoricalItems.length > 0) {
                <ng-select name="categoricalDropdown"
                           id="categoricalDropdown"
                           [items]="categoricalItems"
                           [(ngModel)]="cellData.model[bindProperty]"
                           [bindValue]="categoricalBindBy"
                           class="ng-select-inline-edit"
                           [clearable]="enableCustomCategoricalItem"
                           (blur)="handleBlur()"
                           (keydown)="handleKeyDown($event)"
                           [addTag]="enableCustomCategoricalItem"
                           [addTagText]="'global.add-custom-value' | translate"
                           [selectOnTab]="enableCustomCategoricalItem"
                           [hideSelected]="false"
                           [editableSearchTerm]="enableCustomCategoricalItem"
                           (change)="onChange($event)"
                           [dropdownPosition]="categoricalDropdownPosition"
                           [searchable]="true"
                           [searchFn]="categoricalSearchFn.bind(this, isCategoricalDescriptionView)"
                           #inputElement>
                    <ng-template ng-label-tmp let-item="item">
                        @if(!item) {
                        } @else if(isCategoricalDescriptionView) {
                            <div title="{{item.description}}">{{item.name}} - {{item.description}} </div>
                        } @else {
                            <div title="{{item.name}}">{{item.name}}</div>
                        }
                    </ng-template>
                    <ng-template ng-option-tmp let-possibleValue="item">
                        @if (isCategoricalDescriptionView) {
                            <div title="{{possibleValue.description}}">{{possibleValue.name}} - {{possibleValue.description}} </div>
                        } @else {
                            <div title="{{possibleValue.name}}">{{possibleValue.name}}</div>
                        }
                    </ng-template>
                </ng-select>
            }

            @if (!isLocation() && categoricalItems && categoricalItems.length === 0) {
                <input type="text"
                       class="text-input"
                       [(ngModel)]="cellData.model[bindProperty]"
                       (blur)="handleBlur()"
                       (keydown)="handleKeyDown($event)"
                       #inputElement>
            }
        }

        @case ('N') {
            <input type="number"
                   class="number-input"
                   [(ngModel)]="cellData.model[bindProperty]"
                   (blur)="handleBlur()"
                   (keydown)="handleKeyDown($event)"
                   #inputElement>
        }

        @case ('T') {
            <input type="text"
                   class="text-input"
                   maxlength="255"
                   [(ngModel)]="cellData.model[bindProperty]"
                   (blur)="handleBlur()"
                   (keydown)="handleKeyDown($event)"
                   #inputElement>
        }

        @case ('D') {
            <div class="d-flex">
                <input class="form-control date-input"
                       [placeholder]="'global.date.no.dash.placeholder' | translate"
                       [(ngModel)]="cellData.model[bindProperty]"
                       [placement]="'auto'"
                       [container]="'body'"
                       [autoClose]="true"
                       (keydown)="handleKeyDown($event)"
                       (blur)="handleBlur()"
                       (dateSelect)="handleBlur()"
                       ngbDatepicker #inputElement #datepicker="ngbDatepicker">
                <div class="justify-content-end">
                    <button class="btn btn-sm btn-outline-secondary calendar" (click)="$event.preventDefault(); datepicker.toggle()"
                            (mousedown)="onCalendarMouseDown()"
                            type="button"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
        }
    }
</div>
